<template>
	<div
		class="mb-n2 rounded"
	>
		<v-col style="overflow-y: hidden !important; overflow-x: scroll !important;" v-if="$vuetify.breakpoint.mdAndDown">
			<v-btn-toggle
				class="no-background my-1"
				mandatory
				v-model="selectedOperator"
			>
				<v-btn
					class="btn-round mx-3"
					color="white"
					fab
					:disabled="loadingTariffs || configuratorType == 'EDIT'"
					elevation="0"
					v-for="(image, index) in filterOps"
					:key="index"
					active-class="grey"
				>
					<div class="flex-column pa-12">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<img
									v-bind="attrs"
									v-on="on"
									:key="index"
									:src="image.url"
									:alt="image.alt"
									:height="image.alt != 'LOWIPARTICULAR' ? 30 : 10"
								/>
							</template>
							<div>
								<v-row
									class="d-flex justify-center text-center"
									no-gutters
								>
									<v-col cols="12">{{
										titleCase(image.isp)
									}}</v-col>
								</v-row>
								<v-row
									class="d-flex justify-center text-center"
									no-gutters
								>
									<v-col cols="12">{{
										titleCase(image.segment)
									}}</v-col>
								</v-row>
							</div>
						</v-tooltip>
					</div>
				</v-btn>
			</v-btn-toggle>
		</v-col>

		<div v-if="!$vuetify.breakpoint.mdAndDown" cols="12">
			<v-btn-toggle
				class="d-flex no-background my-1 justify-center"
				mandatory
				v-model="selectedOperator"
				style="overflow-y: hidden !important; overflow-x: scroll !important;"
			>
				<v-btn
					x-large
					class="btn-round mx-6"
					color="white"
					fab
					:disabled="loadingTariffs || configuratorType == 'EDIT'"
					elevation="0"
					v-for="(image, index) in filterOps"
					:key="index"
					active-class="grey"
				>
					<div class="flex-column pa-12">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<img
									style="margin-top: 4px;"
									v-bind="attrs"
									v-on="on"
									:key="index"
									:src="image.url"
									:alt="image.alt"
									:height="imageSizeIsp(image.isp)"
								/>
							</template>
							<div>
								<v-row
									class="d-flex justify-center text-center"
									no-gutters
								>
									<v-col cols="12">{{
										titleCase(image.isp)
									}}</v-col>
								</v-row>
								<v-row
									class="d-flex justify-center text-center"
									no-gutters
								>
									<v-col cols="12">{{
										titleCase(image.segment)
									}}</v-col>
								</v-row>
							</div>
						</v-tooltip>
					</div>
				</v-btn>
			</v-btn-toggle>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
	name: 'ConfiguratorNav',
	data: () => ({
		toggle_one: null,
		filteredImages: [],
		images: [
			{
				url: '/yoigo.png',
				alt: 'YOIGOPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'YOIGO',
			},
			{
				// url: '/dbl.png',
				url: '/yoigopro.png',
				alt: 'YOIGONEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'YOIGO',
			},
			{
				url: '/yoigodbl.png',
				alt: 'YOIGODBLNEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'DBL',
			},
			{
				url: '/masmovil.png',
				alt: 'MASMOVILPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'GRUPO MM',
			},
			{
				url: '/masmovilpro.png',
				alt: 'MASMOVILNEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'GRUPO MM',
			},
			{
				url: '/masmovildbl.png',
				alt: 'MASMOVILDBL',
				segment: 'NEGOCIOS',
				isp: 'GRUPO MM DBL',
			},
			{
				url: '/pepephone.png',
				alt: 'PEPEPHONEPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'PEPEPHONE',
			},
			{
				url: '/lebara.png',
				alt: 'LEBARAPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'LEBARA',
			},
			{
				url: '/llamaya.png',
				alt: 'LLAMAYAPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'LLAMAYA',
			},
			{
				url: '/virgin.png',
				alt: 'VIRGINPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'VIRGIN',
			},
			{
				url: '/virginpro.png',
				alt: 'VIRGINNEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'VIRGIN',
			},
			{
				url: '/vodafone.png',
				alt: 'VODAFONEPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'VODAFONE',
			},
			{
				url: '/vodafonepro.png',
				alt: 'VODAFONENEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'VODAFONE',
			},
			{
				url: '/lowi.png',
				alt: 'LOWIPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'LOWI',
			},
			{
				url: '/otros.png',
				alt: 'OTROSPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'OTROS',
			},
			{
				url: '/otrospro.png',
				alt: 'OTROSNEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'OTROS',
			},
			{
				url: '/avatel.png',
				alt: 'AVATELPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'AVATEL',
			},
			{
				url: '/avatelpro.png',
				alt: 'AVATELNEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'AVATEL',
			},
			{
				url: '/finetwork.png',
				alt: 'FINETWORKPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'FINETWORK',
			},
			{
				url: '/finetworkpro.png',
				alt: 'FINETWORKNEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'FINETWORK',
			},
			{
				url: '/adamo.png',
				alt: 'ADAMOPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'ADAMO',
			},
			{
				url: '/adamopro.png',
				alt: 'ADAMONEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'ADAMO',
			},
			{
				url: '/digi.png',
				alt: 'DIGIPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'DIGI',
			},
			{
				url: '/digipro.png',
				alt: 'DIGINEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'DIGI',
			},
			{
				url: '/movistar.png',
				alt: 'MOVISTARPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'MOVISTAR',
			},
			{
				url: '/movistarpro.png',
				alt: 'MOVISTARNEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'MOVISTAR',
			},
			{
				url: '/o2.png',
				alt: 'O2PARTICULAR',
				segment: 'PARTICULAR',
				isp: 'O2',
			},
			{
				url: '/o2pro.png',
				alt: 'O2NEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'O2',
			},
			{
				url: '/jazztel.png',
				alt: 'JAZZTELPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'JAZZTEL',
			},
			{
				url: '/jazztelpro.png',
				alt: 'JAZZTELNEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'JAZZTEL',
			},
			{
				url: '/orange.png',
				alt: 'ORANGEPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'ORANGE',
			},
			{
				url: '/orangepro.png',
				alt: 'ORANGENEGOCIOS',
				segment: 'NEGOCIOS',
				isp: 'ORANGE',
			},
			{
				url: '/simyo.png',
				alt: 'SIMYOPARTICULAR',
				segment: 'PARTICULAR',
				isp: 'SIMYO',
			},
		],
	}),
	computed: {
		...mapState('configuradorOferta', {
			loadingTariffs: (state) => state.loadingTariffs,
			configuratorType: (state) => state.configuratorType,
		}),
		selectedOperator: {
			get() {
				// En la store almacenamos el nombre del operador, pero btn-toggle necesita que se le pase un indice.
				// Con esta función lo buscamos dentro del array images para que funcione correctamente

				if (this.$store.state.configuradorOferta.isp) {
					return this.filterOps.findIndex(
						(isp) =>
							isp.isp ===
								this.$store.state.configuradorOferta.isp.isp &&
							isp.segment ===
								this.$store.state.configuradorOferta.isp.segment
					);
				}
			},
			set(val) {
				// Buscamos el nombre de la compañía dentro del array para almacenar su nombre en la store
				this.$store
					.dispatch('configuradorOferta/reset')
					.then(
						this.$store.commit(
							'configuradorOferta/isp',
							this.filterOps[val]
						),
						this.getTariffs(),
						this.getAdditionals(),
						this.getTerminals()
					);

				// console.log('operador');
				// console.log(this.filterOps[val]);
			},
		},
		filterOps() {
			let tenantSell = JSON.parse(
				localStorage.getItem('tenantInfo')
			).selling_companies;

			if (tenantSell) {
				let filteredImages = [];

				this.images.forEach((image) => {
					let isp = image.isp == 'DBL' ? 'YOIGO_DBL' : image.isp;
					let segment = image.segment;

					if (
						tenantSell.includes(
							(isp + '_' + segment).replaceAll(' ', '')
						)
					) {
						filteredImages.push(image);
					}
				});

				return filteredImages;
			}

			return [];
		},
	},
	methods: {
        imageSizeIsp(isp) {
            switch (isp) {
                case 'OTROS':
                    return 60;
                case 'AVATEL':
                    return 30;
				case 'VODAFONE':
					return 60;
				case 'LOWI':
					return 20;
				case 'DIGI':
					return 20;
                default:
                    return 40;
            }
        },
		titleCase(str) {
			var splitStr = str.toLowerCase().split(' ');
			for (var i = 0; i < splitStr.length; i++) {
				// You do not need to check if i is larger than splitStr length, as your for does that for you
				// Assign it back to the array
				if (splitStr[i].length > 3)
					splitStr[i] =
						splitStr[i].charAt(0).toUpperCase() +
						splitStr[i].substring(1);
				else splitStr[i] = splitStr[i].toUpperCase();
			}
			// Directly return the joined string
			return splitStr.join(' ');
		},
		...mapActions('configuradorOferta', [
			'getTariffs',
			'getAdditionals',
			'getTerminals',
		]),
	},
};
</script>

<style>
.btn-round {
	border-radius: 50px !important;
}
.no-background {
	background: none !important;
}

@media (max-width: 768px) {
	.btn-round {
		border-radius: 50% !important;
		height: 55px !important;
	}
}
</style>